export default __webpack_public_path__ + "static/media/tennis-gold-thumbnail.e02f79bc.png";